import '../CsvJsonInfoPages.scss';


function GenericDescriptions() {

    const data = [
        { field: 1, description: 'Generic Code (Int)' },
        { field: 2, description: 'Manufacturer Code (Int)' },
        { field: 3, description: 'Category Code (Int)' },
        { field: 4, description: 'Description (Char)' },
        { field: 5, description: 'Long Description (Char)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Technical Descriptions</h1>
            <p>This file contains the descriptions for all Generic Items.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryGeneric.txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryGeneric.txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryGeneric.txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryGeneric.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p>Note: A manufacturer code of zero means the option is Common to multiple manufacturers.</p>

        </div>
    );
}

export default GenericDescriptions;
